import { Component, ElementRef, Inject, LOCALE_ID, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { EnvironmentService, EnvironmentSettings } from '../../services/environment/environment.service';
import { NavigationService } from '../../services/navigation/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { ResponsiveDirective } from '../../../../../projects/qo-commons/src/directives/responsive';
import { NgIf, NgTemplateOutlet, NgClass } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { InViewDirective } from '../../../../../projects/qo-commons/src/directives/in-view.directive';

@Component({
    selector: 'qo-header',
    templateUrl: './header.component.html',
    imports: [ResponsiveDirective, NgIf, RouterLink, NgTemplateOutlet, MatRipple, MatIcon, InViewDirective, NgClass]
})
export class HeaderComponent implements OnDestroy {

    @ViewChild("scrollTarget") scrollTarget?: ElementRef;

    NavigationService = NavigationService;
    environmentSettings: EnvironmentSettings;

    productMenuOpen = false;
    displayDiscover: boolean = false;
    displayProducts: boolean = false;
    displayResources: boolean = false;

    showBanner: boolean = false;

    bannerLink: string = "https://webforms.pipedrive.com/f/ccIc1ybGfgLsInC6xe8pQfbztKusp5okmV9kEqXIeOuqVDzDgGR2GUoYWd3hbwxNT5";

    ressourcesAccreditationGuideLink: string = "https://blog.quick-off.com/2025/07/10/accreditation-evenementielle-et-controle-dacces-les-fondamentaux-pour-une-logistique-fluide-et-securisee-guide-gratuit/";
    ressourcesVolunteerStudyLink: string = "https://blog.quick-off.com/2025/04/10/etude-2025-sur-le-benevolat-evenementiel-chiffres-analyses-et-leviers-daction/";
    ressourcesVolunteeringLegalLink: string = "https://blog.quick-off.com/2024/10/14/nouveau-guide-benevolat-evenementiel-reperes-juridiques-et-bonnes-pratiques%f0%9f%93%96/";

    private _displayMenu: boolean = false;
    public get displayMenu(): boolean { return this._displayMenu; }
    public set displayMenu(value: boolean) {
        if (this._displayMenu !== value) {
            this._displayMenu = value;
            if (value) {
                this.dialog.open(MobileMenuComponent,{width: "100%", height: "100%", maxWidth: "100%"})
                    .afterClosed().subscribe((routerLinks?:any) => {
                        this._displayMenu = false;
                        if(routerLinks) this.router.navigate(routerLinks);
                    });
            }
        }
    }

    constructor(public router: Router,
        private dialog: MatDialog,
        environmentService: EnvironmentService,
        @Inject(LOCALE_ID) public locale: string) {
            if(this.locale === 'fr') {
                this.showBanner = true;
            }
            this.environmentSettings = environmentService.settings;
            router.events
                .pipe(
                    takeUntil(this.$destroy),
                    filter(event => event instanceof NavigationStart)
                )
                .subscribe(() => {
                    this.displayMenu = false;
                });
    }

    private $destroy = new Subject<boolean>();
    ngOnDestroy(): void {
        this.$destroy.next(true);
        this.$destroy.complete();
    }
}
